// src/pages/docs/etc/prefix.jsx
import { Typography, Box, Button } from '@mui/material';
import DocsLayout from 'layout/DocsLayout';
import commandList from 'data/commands';
import { useLocation } from 'react-router-dom';
import { getAdjacentCommands } from 'components/getAdjacentCommands';

const PrefixCommand = () => {
    const location = useLocation();
    const command = commandList.find((cmd) => cmd.path === location.pathname);
    const { prev, next } = getAdjacentCommands(location.pathname);
    return(
        <DocsLayout>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 4, flexWrap: 'wrap', maxWidth:750 }}>
            {/* 왼쪽 텍스트 영역 */}
            <Box sx={{ flex: 1, minWidth: 260 }}>
                <Typography variant="h4" fontWeight="bold" gutterBottom>
                /접두사변경
                </Typography>
                <Typography variant="body1" sx={{ mt: -2, mb: 3 }}>
                    {command?.description ?? '설명이 없습니다.'}
                </Typography>
                <Typography variant="h6">
                {"사용법: /접두사변경 <변경할 접두사>"}
                </Typography>
            </Box>

            {/* 오른쪽 이미지 영역 */}
            <Box
                component="img"
                src="/commands/prefix.webp"
                alt="접두사 변경"
                sx={{
                width: '100%',
                maxWidth: 400,
                borderRadius: 2,
                flexShrink: 0,
                mx: 'auto',
                }}
            />
            <Box
                sx={{
                  display: 'flex',
                  justifyContent: { xs: 'center', md: 'space-between' },
                  gap: 4,
                  width: { xs: '100%',md: 'auto' },

                }}
              >
              {prev && (
                <Button href={prev.path} variant="outlined"sx={{height: 36, width:118 }}>
                  ← {prev.name}
                </Button>
              )}
              {next && (
                <Button href={next.path} variant="outlined"sx={{height: 36}}>
                  {next.name} →
                </Button>
              )}
              </Box>
            </Box>
        </DocsLayout>
    );
};

export default PrefixCommand;
